import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LstRouterModule } from '@savvaslearning/lst-auth';
import { MultiStageAuthGuard } from './core/multi-stage-assignment-report/guard/multi-stage-auth.guard';
import { ROUTE_PATHS } from './shared/common.constants';
import { ErrorComponent } from './shared/components/error/error.component';

const routes: Routes = [
    {
        path: ROUTE_PATHS.ROOT_PATH,
        canActivate: [MultiStageAuthGuard],
        loadChildren: () =>
            import('./multi-stage-report/multi-stage-report.module').then((m) => m.MultiStageReportModule),
    },
    {
        path: ROUTE_PATHS.MSDA_REPORT_LOADER,
        canActivate: [MultiStageAuthGuard],
        loadChildren: () =>
            import('./multi-stage-report-loader/multi-stage-report-loader.module').then(
                (m) => m.MultiStageReportLoaderModule,
            ),
    },
    {
        path: 'error',
        component: ErrorComponent,
    },
    { path: '**', redirectTo: 'error' },
];

@NgModule({
    imports: [LstRouterModule.getRoutes(), RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
